"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateToJSON = exports.TemplateFromJSONTyped = exports.TemplateFromJSON = exports.instanceOfTemplate = exports.TemplateRequestTypeEnum = exports.attributeTypeMapTemplate = void 0;
var RecipientItemsJoined_1 = require("./RecipientItemsJoined");
var ModelFile_1 = require("./ModelFile");
var EditorFields_1 = require("./EditorFields");
var Document_1 = require("./Document");
var CCItemsJoined_1 = require("./CCItemsJoined");
exports.attributeTypeMapTemplate = [
    {
        name: "guid",
        type: "string",
    },
    {
        name: "templateGuid",
        type: "string",
    },
    {
        name: "requestType",
        type: "number",
    },
    {
        name: "recipientReassignment",
        type: "boolean",
    },
    {
        name: "recipientOrder",
        type: "boolean",
    },
    {
        name: "dateFormat",
        type: "string",
    },
    {
        name: "jsDateFormat",
        type: "string",
    },
    {
        name: "files",
        type: "Array<ModelFile>",
    },
    {
        name: "editorFields",
        type: "EditorFields",
    },
    {
        name: "recipients",
        type: "Array<RecipientItemsJoined>",
    },
    {
        name: "ccs",
        type: "Array<CCItemsJoined>",
    },
    {
        name: "document",
        type: "Document",
    },
];
/**
 * @export
 */
exports.TemplateRequestTypeEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_7: 7,
    NUMBER_8: 8,
    NUMBER_9: 9,
    NUMBER_10: 10,
    NUMBER_11: 11,
    NUMBER_12: 12,
    NUMBER_13: 13,
    NUMBER_14: 14,
};
/**
 * Check if a given object implements the Template interface.
 */
function instanceOfTemplate(value) {
    if (!("guid" in value) || value["guid"] === undefined)
        return false;
    if (!("templateGuid" in value) || value["templateGuid"] === undefined)
        return false;
    if (!("requestType" in value) || value["requestType"] === undefined)
        return false;
    if (!("recipientReassignment" in value) ||
        value["recipientReassignment"] === undefined)
        return false;
    if (!("recipientOrder" in value) || value["recipientOrder"] === undefined)
        return false;
    if (!("dateFormat" in value) || value["dateFormat"] === undefined)
        return false;
    if (!("jsDateFormat" in value) || value["jsDateFormat"] === undefined)
        return false;
    if (!("files" in value) || value["files"] === undefined)
        return false;
    if (!("editorFields" in value) || value["editorFields"] === undefined)
        return false;
    if (!("recipients" in value) || value["recipients"] === undefined)
        return false;
    if (!("ccs" in value) || value["ccs"] === undefined)
        return false;
    if (!("document" in value) || value["document"] === undefined)
        return false;
    return true;
}
exports.instanceOfTemplate = instanceOfTemplate;
function TemplateFromJSON(json) {
    return TemplateFromJSONTyped(json, false);
}
exports.TemplateFromJSON = TemplateFromJSON;
function TemplateFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        guid: json["guid"],
        templateGuid: json["template_guid"],
        requestType: json["request_type"],
        recipientReassignment: json["recipient_reassignment"],
        recipientOrder: json["recipient_order"],
        dateFormat: json["date_format"],
        jsDateFormat: json["js_date_format"],
        files: json["files"].map(ModelFile_1.ModelFileFromJSON),
        editorFields: (0, EditorFields_1.EditorFieldsFromJSON)(json["editor_fields"]),
        recipients: json["recipients"].map(RecipientItemsJoined_1.RecipientItemsJoinedFromJSON),
        ccs: json["ccs"].map(CCItemsJoined_1.CCItemsJoinedFromJSON),
        document: (0, Document_1.DocumentFromJSON)(json["document"]),
    };
}
exports.TemplateFromJSONTyped = TemplateFromJSONTyped;
function TemplateToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        guid: value["guid"],
        template_guid: value["templateGuid"],
        request_type: value["requestType"],
        recipient_reassignment: value["recipientReassignment"],
        recipient_order: value["recipientOrder"],
        date_format: value["dateFormat"],
        js_date_format: value["jsDateFormat"],
        files: value["files"].map(ModelFile_1.ModelFileToJSON),
        editor_fields: (0, EditorFields_1.EditorFieldsToJSON)(value["editorFields"]),
        recipients: value["recipients"].map(RecipientItemsJoined_1.RecipientItemsJoinedToJSON),
        ccs: value["ccs"].map(CCItemsJoined_1.CCItemsJoinedToJSON),
        document: (0, Document_1.DocumentToJSON)(value["document"]),
    };
}
exports.TemplateToJSON = TemplateToJSON;
